export default {
    login: {
        title: 'Welcome to login',
        mobile: 'Please enter your mobile',
        password: 'Please enter your password',
        confirmPwd: 'Please enter the confirmation password',
        verificationCode: 'Please enter the verification code',
        loginIn: 'Login',
        register: 'Register',
        reset: 'Reset',
        resetPwd: 'Reset Password',
        newPwd: 'Please enter a new password'
    },
    Notification: {
        suc_title: 'Success',
        suc_login_msg: 'Login Success',
        suc_send_msg: 'Login Success',
        codeAgain: 'Recapture Captcha',
        suc_submit: 'Submit Success',
        login_tip: 'Please Log In First',
        tip: 'Tip',
        sure: 'Sure',
        next: 'Next',
        requiredFields: 'Please complete the required fields',
        nodata: 'No Data',
        read: 'Read',
        unread: 'Unread',
        cancel: 'Cancel',
        print: 'Print',
        submit_tip: 'Confirm that no modification can be made after submission. Whether to continue',
        suc_confirm_msg: 'Successful Confirmation',
        profile_photo: 'profile photo',
        no: 'No.',
        filemessage: 'upload files',
        min_file: 'the minimum number of uploads is',
        errorTouGao: 'Submission time has expired'
    },
    tougao: {
        submit: 'Submit',
        correct_mobile: 'Please enter the correct mobile',
        correct_email: 'Please enter the correct email',
        corrent_card: 'Please enter the correct Card',
        basic_info: 'Member Info',
        zuopin_info: 'Work Info',
        cancel: 'Cancel',
        sure: 'Sure',
        receipt: 'Submission Receipt'
    },
    my: {
        name: 'Name',
        category: 'Category',
        ticket: 'Ticket',
        status: 'Status',
        operate: 'Operate',
        edit: 'Edit',
        confirm: 'Confirm',
        view: 'View',
        receipt: 'Receipt',
        logout: 'Logout'
    }
}
